import React from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {useServices} from "../../../../hooks/use-services.hook";

const StandByLabelBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    color: ${props => props.theme.colors.dangerShade};
    font-weight: ${props => props.theme.fontWeight.semiBold};
`

export const StandByLabelComponent: React.FC = observer(() => {
    const services = useServices();

    return (
        <StandByLabelBox>
            {services.language.translate('Standby')}
        </StandByLabelBox>
    );
})
